import {h, Component} from 'preact';
import cx from 'classnames'
import moment from 'moment';

interface InquiryDateIndicatorProps {
  date?: string;
  highlighted?: boolean;
}

interface InquiryDateIndicatorState {}

export class InquiryDateIndicator extends Component<InquiryDateIndicatorProps, InquiryDateIndicatorState> {

  render() {
    const { date, highlighted } = this.props;
    
    return (
      <div className="hi-inqcard__movein-date">
        <span className={ cx("hi-inqcard__movein-month", {
          'text-secondary': highlighted
        }) }>{ moment(date).format('MMM') }</span>
        
        <span className={ cx("hi-inqcard__movein-day", {
          'text-secondary': highlighted
        }) }>{ moment(date).format('D') }</span>
      </div>
    )
  }
}
